@if (dashboard !== true) {
  <div
    class="yCmsContentSlot account-section-content reports-page"
    >
    <div class="row row-20">
      <div class="col-md-5 col-sm-6 col-xs-12">
        <h1 class="prodCat-title">Reports</h1>
      </div>
    </div>
    <div class="row row-20" id="leftCont-rightNav">
      <div class="col-md-12 col-lg-8 border-right">
        <div class="left-section-wrapper row">
          <div class="col-md-12 p0 reportBannerSlt">
            @if (baseSiteId === "vsh") {
              <img title="" alt="" src="/img/reports-page-img.png" />
            }
            @if (baseSiteId === "vax") {
              <img title="" alt="" src="/img/report-vax.png" />
            }
          </div>
          <div class="col-md-12 p0">
            <div class="need-for-reports">
              <div class="content">
                <h4 class="ff-bold m0 fs-14">
                  Understand your business needs using
                </h4>
                @if (baseSiteId === "vsh") {
                  <h1 class="main-heading">
                    VaccineShop Reports
                  </h1>
                }
                @if (baseSiteId === "vax") {
                  <h1 class="main-heading">
                    VaxServe Reports
                  </h1>
                }
                <p class="fs-14">
                  Now you can get insights on your purchasing insights, discounts,
                  and savings to help you adjust to your business needs.
                </p>
                <p class="access-reports fs-14">Access a range of reports:</p>
              </div>
              @if (isLoggedInUser === true) {
                <div class="content">
                  <ul class="multiple-links">
                    @for (reports of reportsList; track reports; let i = $index) {
                      <li
                        [ngClass]="{ hideDiv: reports.description === undefined }"
                        >
                        <p class="ff-bold light-color fs-14 m0">
                          {{ reports.description }}
                        </p>
                        <button
                          class="launch-report btn-primary"
                          (click)="getreportDetails(reports.reportId)"
                          >
                          Launch report
                        </button>
                      </li>
                    }
                  </ul>
                </div>
              }
              @if (isLoggedInUser === false) {
                <div class="content">
                  <ul class="single-layout">
                    @for (type of typesOfReoprts; track type) {
                      <li
                  [ngStyle]="{
                    'background-image':
                      'url(/icons/' +
                      baseSiteId +
                      '/checkmark.svg)'
                  }" class="ff-bold fs-14"
                        >
                        {{ type }}
                      </li>
                    }
                    <button
                  class="
                    ad-blue-button
                    login-btn
                    access-reports-btn
                    btn-primary
                  "
                      (click)="navigateToLogInPage()"
                      >
                      Log in to access reports
                    </button>
                  </ul>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-4">
        <!-- <div class="right-section-wrapper">
        <img *ngIf='baseSiteId === "vsh"'
          title="horizantal banner"
          alt="horizantal banner"
          src="/img/horizontal_300.gif"
          />
      </div> -->
    </div>
  </div>
</div>
}
@if (dashboard === true) {
  <div class="content else-case">
    <div class="row acc-chart">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 sanofi-chart-text">
        <h3>Reports</h3>
        <p class="chart-acc">
          Now you can get insights on your purchasing insights, discounts, and
          savings to help you adjust to your business needs.
        </p>
        <div class="row">
          <div class="col-md-12 ac-report">
            <p>Access a range of reports:</p>
            <ul>
              @for (type of typesOfReoprts; track type) {
                <li
                [ngStyle]="{
                  'background-image':
                    'url(/icons/' +
                    baseSiteId +
                    '/checkmark.svg)'
                }"
                  >
                  {{ type }}
                </li>
              }
            </ul>
            <div class="launchMyDashboard">
              <button type="button" (click)="goToReports()" class="btn-primary">
                Launch my dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6">
        <div class="ct-donut-wrapper">
          <br />@if (baseSiteId === "vsh") {
          <img src="/img/reports-page-img.png" alt="" />
        }
        @if (baseSiteId === "vax") {
          <img title="" alt="" src="/img/report-vax.png" />
        }
      </div>
    </div>
  </div>
</div>
}
